<div>
  <div class="a-title">
    <i class="fa-solid fa-comment"></i>
    <span>{{ translationManager.getTranslation('Комуникација') }}</span>
  </div>
  <div class="alert alert-info amb-15">
    <span><i class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Преглед намењен размени порука за изабрани тикет') }}</span>
  </div>
  <div class="chat amb-15">
    <div class="messages" #messageItems>
      <div class="items">
        <div class="message" [ngClass]="{ left: item.messageFromUserId != auth.user?.id, right: item.messageFromUserId == auth.user?.id }" *ngFor="let item of items">
          <div>
            <div class="user">
              <span>{{ item.messageFromUserInitials }}</span>
            </div>
            <div class="message-content">
              <i class="fa-solid fa-caret-left"></i>
              <i class="fa-solid fa-caret-right"></i>
              <div class="message-info">
                <span>{{ item.messageFromUserFullName }}</span>
              </div>
              <div class="message-content-data">
                <span><pre style="text-wrap:balance;text-align:justify;">{{ item.message }}</pre></span>
              </div>
              <div class="message-time">
                <span>{{ item.messageCreatedOn | appdate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="send-message" *ngIf="form.elements['panelSendMessage'].state.visible">
      <div class="form-element" [ngClass]="{ 'error': form.elements['message'].error.required }">
        <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
          <textarea [(ngModel)]="form.elements['message'].value" [placeholder]="translationManager.getTranslation('Пошаљи поруку')" style="min-height: 100px"></textarea>
        </div>
      </div>
      <div class="send">
        <a [title]="translationManager.getTranslation('Пошаљи поруку')" href="javascript:;" (click)="sendMessage()"><i class="fa-solid fa-envelope"></i></a>
      </div>
    </div>
  </div>
</div>
<message-modal #messageModal [title]="'Информације'" [buttons]="[{ id: 'OK', title: translationManager.getTranslation('У реду'), look: 'btn-success', lookIcon: 'fa-check' }]"></message-modal>
